import React, { useEffect, useState } from "react";
import ImageCard from "../ImageCard";
import { Link } from "react-router-dom";

const SellerProjectCard = ({
  userId,
  userTitle,
  userLocation,
  userType,
  percentage,
  TransactionDone,
  isProfileDescription = false
}) => {
  const projectImage =
    userType === "buyer" || userType === "trader"
      ? "/images/userimgone.png"
      : "/images/userimgtwo.png";
  return (
    <Link to={`/profile-description/${userId}`}>
      {!isProfileDescription && (
        <div className="flex w-full  bg-white rounded-2xl h-24 mb-4">
          <div className="ml-1 text-center capitalize">
            <ImageCard
              iconDisplay="flex"
              classnames="w-[12.625rem] h-24 bg-cover m-auto  flex items-center justify-center text-2xl font-bold text-white rounded-tl-2xl rounded-bl-2xl"
              userImage={projectImage}
            >
              {userType}
            </ImageCard>
          </div>
          <div className="flex w-full px-6 pb-2">
            <div className="w-full">
              <div className="flex justify-between w-full">
                <div className="flex">
                  <h1 className=" mt-3 text-black-700 text-start text-2xl font-bold pr-3 capitalize ">
                    {userTitle}
                  </h1>
                  <h2 className="mt-6 text-xs font-medium ">{userLocation}</h2>
                </div>
                <div>
                  <h2 className="mt-6 text-[10px] font-light pb-2 text-blue-800">
                    {TransactionDone}-Transaction Done
                  </h2>
                </div>
              </div>
              <div></div>
              <div>
                <div className="flex justify-between">
                  <div className="text-[12px] lg:text-[12px] lg:text-blue-800 lg:font-medium  ">
                    Authenticity
                  </div>
                  <div className="text-blue-800 text-xs">{percentage?.toFixed(2)}%</div>
                </div>
                <div className="w-full bg-grey-300 mt-1 rounded-full">
                  <div
                    className="h-1 rounded-full bg-blue-800"
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isProfileDescription && (
        <div className="flex w-[400px] h-[69px]  ml-6  bg-white rounded-2xl mb-4 border-b border-grey-200 shadow-md">
          <div className="ml-1 my-1 text-center capitalize">
            <ImageCard
              iconDisplay="flex"
              classnames="w-[127px] h-[67px]  bg-cover m-auto rounded-tl-* rounded-bl-lg flex items-center justify-center text-2xl font-bold text-white"
              userImage={projectImage}
            >
              <p className="text-base">{userType}</p>
            </ImageCard>
          </div>
          <div className="flex w-[350px]  pl-6">
            <div className="flex flex-col">
              <h1 className="text-base mt-3 lg:text-black-700 lg:text-start lg:text-base lg:font-bold">
                {userTitle}
              </h1>
              <div className="flex">
                <img src="/images/location.svg" alt="/" />
                <h2 className=" pl-3 lg:text-xs lg:font-medium ">
                  {userLocation}
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
    </Link>
  );
};

export default SellerProjectCard;
